import axios from 'axios';
import { tokenService } from './auth/tokenService';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  async (config) => {
    if (tokenService.isTokenExpired()) {
      try {
        // Intentar renovar el token
        const refresh_token = tokenService.getRefreshToken();
        if (refresh_token) {
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/auth/refresh`,
            { 
              refresh_token: refresh_token
            }
          );
          if (response.data.access_token) {
            tokenService.setTokens(response.data);
          }
        }
      } catch (error) {
        // Si falla la renovación, limpiar tokens y redirigir al login
        tokenService.clearTokens();
        window.location.href = '/';
        return Promise.reject('Session expired');
      }
    }

    const token = tokenService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Limpiar tokens y redirigir al login
      tokenService.clearTokens();
      //window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
